import { render } from "./SideBar.vue?vue&type=template&id=bd4b0dee&scoped=true"
import script from "./SideBar.js?vue&type=script&lang=js&external"
export * from "./SideBar.js?vue&type=script&lang=js&external"

import "./SideBar.vue?vue&type=style&index=0&id=bd4b0dee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4b0dee"]])

export default __exports__